module.exports = __webpack_public_path__ + "img/DE05695.008bf6c5.png";